
import { defineComponent, PropType } from 'vue'
import { CouponShowCaseModel } from '@/types/Coupon'

export default defineComponent({
  name: 'CouponPageNormal',
  components: { },
  props: {
    couponShowCaseList: {
      type: Array as PropType<Array<CouponShowCaseModel>>,
      default: () => { return [] }
    }
  },
  methods: {
    CopyCoupon (code: string) {
      (window as any).CopyCouponCode(code)
    },
    CopyAndJump (code: string) {
      (window as any).CopyCouponCode(code)
      setTimeout(() => {
        window.location.href = '/'
      }, 2000)
    }
  }
})
